import { OpsContractorsListView } from '@app/pages/ops-vendor-management/ops-contractors-list/ops-contractors-list.config';

export function filterContractorsList(
  data: OpsContractorsListView[],
  filters: any
): OpsContractorsListView[] {
  return data.filter((contractor) => {
    const vendorMatch = !filters.vendor || contractor.vendor === filters.vendor;
    const statusMatch = !filters.status || contractor.status === filters.status;
    const regularMatch = !filters.regular || contractor.rto === filters.regular;
    const locationMatch = !filters.location || contractor.location === filters.location;
    const managerMatch = !filters.reportingManager || contractor.reportingManager === filters.reportingManager;
    return vendorMatch && statusMatch && regularMatch && locationMatch && managerMatch;
  });
}